import React from "react";
import PropTypes from "prop-types";

const Calendar = ({ month, day, year }) => (
  <div className="calendar">
    <span className="calendar-month">{month}</span>
    <span className="calendar-day d-flex flex-column">
      <span>{day}</span>
      <span className="fs-10 mt-2">{year}</span>
    </span>
  </div>
);

Calendar.propTypes = {
  month: PropTypes.string.isRequired,
  day: PropTypes.string.isRequired,
};

export default Calendar;
